// SequenceService.js

//==========================================================
//
// A service that handles getting increasing 
// sequence numbers. Uses session storage
// to persist order across restarts. Breaks
// sequence if user switches to a new vendor's
// browser, or simply switches client machines.
//
// This module exports a singleton.
//
//
// Lou Mauget, November 19, 2015
//
// PF-1639, November 21, 2016:
//     DOM IDs use UUID V4 suffixes.
//
//==========================================================

import listService      from 'ListService.js';
// import util                 from 'util/Util.js';
import Immutable        from 'immutable';
import uuid             from 'uuid';
import flakeId          from 'flake-idgen';
import intFormatter     from 'biguint-format';
import constants        from 'Constants';

// Default start values for three sequences.
const
    INITA = 0,
    INITB = 4,
    INITC = 9;

class SequenceService {

    constructor() {
        this._tabIndex = Immutable.Map();
        this._tabIndexParentId = '';

        this.flakeid = new flakeId();

        this.resetAll();
    }

    resetAll() {
        this.resetSeq();
        this._tabIndex = Immutable.Map();
        this.resetZIndex();
        this.resetRadioNumber();
        this.resetControlNumber();
    }

    //-------------------------------------

    nextNum() {
        const pfSeq = Number(sessionStorage.pfSeq || -1);
        sessionStorage.pfSeq = pfSeq + 1;
        return sessionStorage.pfSeq;
    }

    resetSeq( x = INITA ) {
        sessionStorage.pfSeq = x - 1;
    }

    // PF-1639
    nextDomId() {
        //return `PF_${uuid.v4()}`;

        const nid = this.flakeid.next();
        return constants.ID_PREFIX + intFormatter(nid, 'dec');
    }

    // PF-1639
    nextCleanId() {
        return this.nextDomId();
    }


    //---------------------------------
    // Need a Array of (ID, IndexValue)
    // Page will have its own, Groups will have their own..
    // Resetting a Index should reset by ID
    resetTabIndex( x = INITA ) {
        //sessionStorage.tabIndex = x - 1;
        let newValue = x;
        if (newValue > 0) { newValue--; }
        this._tabIndex = this._tabIndex.set(this._tabIndexParentId, newValue);
    }

    nextTabIndex() {
        let value = this.peekNextTabIndex();        
        this._tabIndex = this._tabIndex.set(this._tabIndexParentId, value);
        return value;
    }

    peekNextTabIndex() {
        let value = this._tabIndex.get(this._tabIndexParentId);
        
        if (value) {
            value++;
        } else {
            value = 1;
        }
        
        return value;
    }

    get tabIndexParentId() { return this._tabIndexParentId; }
    set tabIndexParentId(id) { this._tabIndexParentId = id; }

    //---------------------------------

    resetZIndex( x = INITC ) {
        sessionStorage.zIndex = x - 1;
    }

    nextZIndex() {
        const zIndex = Number(sessionStorage.zIndex || INITC);
        sessionStorage.zIndex = zIndex + 1;
        return `${sessionStorage.zIndex}`;
    }

    // This is no longer called. Was used by FormLoadService. It uses util, which refs us, SequenceService
/*    setUsedDOMNumbers() {
        let maxNumber = 0;

        const objs = listService.objectList;
        objs.map( (k,v) => {
            const n = util.extractNum( v );
           if (n > maxNumber) {
               maxNumber = n;
           }
        });

        const behCmds = listService.behaviorCommands;
        behCmds.map( (k,v) => {
            const n = util.extractNum( v );
            if (n > maxNumber) {
                maxNumber = n;
            }
        });

        const behInsts = listService.behaviorInstances;
        behInsts.map( (k,v) => {
            const n = util.extractNum( v );
            if (n > maxNumber) {
                maxNumber = n;
            }
        });

        const stages = listService.workflowStages;
        stages.map( (k,v) => {
            const n = util.extractNum( v );
            if (n > maxNumber) {
                maxNumber = n;
            }
        });

        const cmts = listService.workflowComments;
        cmts.map( (k,v) => {
            const n = util.extractNum( v );
            if (n > maxNumber) {
                maxNumber = n;
            }
        });

        const paths = listService.workflowPaths;
        paths.map( (k,v) => {
            const n = util.extractNum( v );
            if (n > maxNumber) {
                maxNumber = n;
            }
        });

        maxNumber++;

        this.resetSeq(maxNumber);

    }*/

    getRadioNumber() {
        return this.radioCount;
    }

    setRadioNumber(number) {
        this.radioCount = number;
    }

    addRadioButton(){
        ++this.radioCount;
    }

    removeRadioButtons(number){
        this.radioCount = this.radioCount - number;
    }

    resetRadioNumber() {
        this.radioCount = 0;
    }

    //---------  Control numbers
    resetControlNumber(){
        this.controlNumber = -1;
    }

    initControlNumber(){
        this.controlNumber = listService.currentForm.model.attributes.nameCounter;
    }

    addControlNumber(){
        let nameCounter =listService.currentForm.model.attributes.nameCounter;
        ++nameCounter;
        listService.currentForm.model.attributes.nameCounter = nameCounter;
    }

    getControlNumber(){
        return listService.currentForm.model.attributes.nameCounter;
    }

}

const sequenceService = new SequenceService;
export default sequenceService;